import { Inbox } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

interface EmptyStateProps {
  monthLabel: string;
}

/**
 * Friendly empty-state card. AOZONE-37: replaces the old right-pane "MBR
 * Draft will appear here" copy when the current month has zero entries.
 */
export function EmptyState({ monthLabel }: EmptyStateProps) {
  return (
    <Card>
      <CardContent className="flex flex-col items-center gap-3 py-16 text-center">
        <div className="rounded-full bg-slate-100 p-3 text-slate-500">
          <Inbox className="h-6 w-6" />
        </div>
        <p className="text-sm font-medium text-slate-700">
          No MBR entries for {monthLabel} yet.
        </p>
        <p className="text-xs text-slate-500">
          Entries posted via{' '}
          <code className="rounded bg-slate-100 px-1 py-0.5 font-mono text-[11px]">
            /mbr create
          </code>{' '}
          in Slack will appear here.
        </p>
      </CardContent>
    </Card>
  );
}
